import { useContext } from 'react';

import { RootContext } from './RootStore';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useStores = () => useContext(RootContext);

export default useStores;
